// extracted by mini-css-extract-plugin
var _1 = "UserGroupsSettings-module__animateUploadProgressBarWidth--nhXA7";
var _2 = "UserGroupsSettings-module__animatedBackground--gVA5k";
var _3 = "UserGroupsSettings-module__description--GrLXu";
var _4 = "UserGroupsSettings-module__formFields--N3Vqx";
var _5 = "UserGroupsSettings-module__formFooter--Pau9N";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "description", _4 as "formFields", _5 as "formFooter" }
